import { Table, Badge } from "antd";
import Layout, { Content, Header } from "antd/es/layout/layout";
import React from "react";
import { useNavigate } from "react-router-dom";
import moment from "jalali-moment";
import Swal from "sweetalert2";

function CustomReviews({ showHeader, header, visits }) {
  const navigate = useNavigate();
  const dataSource = visits?.map((data) => {
    return {
      product: data?.product?.persianName,
      area: data?.area + "هکتار",
      date: moment(data?.createdAt, "YYYY/MM/DD")
        .locale("fa")
        .format("YYYY/MM/DD"),
      location: data?.city,
      state: data,
      operation: data,
    };
  });
  //  const name = test.map(data=> {return {text:data.name ,  value:data.key }})
  // const unique = [
  //   ...new Set(
  //     test.map((data) => {
  //       return { text: data.name, value: data.key };
  //     })
  //   ),
  // ];

  const columns = [
    {
      title: "نوع کشت",
      dataIndex: "product",
      key: "product",
    },
    {
      title: "مساحت",
      dataIndex: "area",
      key: "area",
    },
    {
      title: "تاریخ انجام بازدید",
      dataIndex: "date",
      key: "date",
    },
    {
      title: "منطقه",
      dataIndex: "location",
      key: "location",
    },
    {
      title: "منطقه",
      dataIndex: "status",
      key: "status",
    },
    {
      title: "وضعیت",
      dataIndex: "state",
      key: "state",
      render: (data) => {
        if (
          (data?.currentState === "VISIT_SUPPORT") &
          (data?.subState === "VISIT_SENT") &
          (data?.status === "COMPLETED")
        ) {
          return (
            <Badge
              className="shadow-sm "
              style={{ width: "160px" }}
              color="#207E4F"
              text="تایید شده"
            />
          );
        } else if (
          (data?.currentState === "VISIT_REPORT_WRITING") &
            (data?.subState === null) &
            (data?.status === "PROCESSING") ||
          (data?.currentState === "EDUCATION_MANAGEMENT") &
            (data?.subState === null) &
            (data?.status === "PROCESSING") ||
          (data?.currentState === "VISIT_SUPPORT") &
            (data?.subState === "VISIT_COMPLETED") &
            (data?.status === "PROCESSING")
        ) {
          return (
            <Badge
              className="shadow-sm "
              style={{ width: "160px" }}
              color="#00A9BF"
              text="در حال تکمیل گزارش"
            />
          );
        } else if (
          (data?.currentState === "VISIT_DATA_PROCESS") &
            (data?.subState === null) &
            (data?.status === "PROCESSING") ||
          (data?.currentState === "VISIT_SUPPORT") &
            (data?.subState === "VISIT_FINANCIAL_PROCESSING") &
            (data?.status === "DONE")
        ) {
          return (
            <Badge
              className="shadow-sm "
              style={{ width: "160px" }}
              color="#E8EC18"
              text="پردازش بازدید"
            />
          );
        } else if (
          (data?.currentState === "VISIT_SUPPORT") &
            (data?.subState === "VISIT_FULFILMENT") &
            (data.status === "PROCESSING") ||
          (data?.currentState === "VISIT_SUPPORT") &
            (data?.subState === "VISIT_DONE") &
            (data.status === "DONE")
        ) {
          return (
            <Badge
              className="shadow-sm "
              style={{ width: "160px" }}
              color="#9D9D9D"
              text="انجام بازدید"
            />
          );
        } else {
          return (
            <Badge
              className="shadow-sm "
              style={{ width: "160px" }}
              color="#f10808"
              text="نامشخص"
            />
          );
        }
      },
    },
    {
      title: "عملیات",
      dataIndex: "operation",
      key: "operation",

      render: (data) => {
        if (
          (data?.currentState === "VISIT_SUPPORT") &
            (data?.subState === "VISIT_FULFILMENT") &
            (data.status === "PROCESSING") ||
          (data?.currentState === "VISIT_SUPPORT") &
            (data?.subState === "VISIT_DONE") &
            (data.status === "DONE")
        ) {
          return (
            <button
              style={{
                border: " 1px solid #EEE",
                borderRadius: "15px",
                boxShadow: "0px 2px 8px 0px rgba(219, 219, 219, 0.50)",
                padding: "4px 25px",
              }}
              onClick={() =>
                Swal.fire({
                  confirmButtonText: "متوجه شدم",
                  icon: "info",
                  html: "کارشناس گرامی انجام این بازدید به شما محول شده است لطفا جهت انجام بازدید به اپلیکیشن اگرویار مراجعه نمائید",
                })
              }
            >
              {"شروع بازدید"}
            </button>
          );
        } else if (
          (data?.currentState === "VISIT_SUPPORT") &
          (data?.subState === "VISIT_SENT") &
          (data?.status === "COMPLETED")
        ) {
          return (
            <a
              style={{
                border: " 1px solid #EEE",
                borderRadius: "15px",
                boxShadow: "0px 2px 8px 0px rgba(219, 219, 219, 0.50)",
                padding: "4px 20px",
              }}
              href={data?.reportFile}
              target="_blank"
              rel="noreferrer"
            >
              {"مشاهده گزارش"}
            </a>
          );
        } else {
          return (
            <p
              style={{
                border: " 1px solid #EEE",
                borderRdivdius: "15px",
                boxShadow: "0px 2px 8px 0px rgba(219, 219, 219, 0.50)",
                padding: "4px 6px",
                borderRadius: "20px",
                width: "70%",
                margin: "auto",
                opacity: "50%",
              }}
            >
              مشاهده گزارش
            </p>
          );
        }
      },
    },
  ];

  return (
    <Layout>
      <Content className="bg-white rounded-xl p-3  ">
        <Header hidden={header} className=" bg-white  font-body px-0  ">
          <div className="flex flex-row justify-between border-solid border-2 w-full rounded-2xl px-4 items-center py-3">
            <h2 className="text-base font-normal">بازدید‌ها </h2>
            <button
              hidden
              onClick={() => navigate("showAllVisit")}
              className="text-center text-white text-sm font-normal bg-[#0A66C2] px-3 rounded-2xl h-7"
            >
              مشاهده همه
            </button>
          </div>
        </Header>

        <Table
          scroll={{
            x: 900,
          }}
          showHeader={showHeader}
          pagination={false}
          style={{
            fontFamily: "body",
          }}
          dataSource={dataSource}
          columns={columns}
        ></Table>
      </Content>
    </Layout>
  );
}

export default CustomReviews;
